//#region src/utils/mock-react-synthetic-event.ts
var createMockReactSyntheticEvent = ({ id, name, value } = {}) => ({
	bubbles: false,
	cancelable: false,
	currentTarget: {
		id,
		name,
		value
	},
	defaultPrevented: false,
	eventPhase: 0,
	isDefaultPrevented: () => true,
	isPropagationStopped: () => true,
	isTrusted: false,
	nativeEvent: {},
	persist: () => void 0,
	preventDefault: () => void 0,
	stopPropagation: () => void 0,
	target: {
		id,
		name,
		value
	},
	timeStamp: 0,
	type: ""
});
createMockReactSyntheticEvent();
//#endregion
export { createMockReactSyntheticEvent };

//# sourceMappingURL=mock-react-synthetic-event.js.map